import React from 'react';
import styled from '@emotion/styled';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { AboutService } from 'ui/components/buyer/features/AboutService';
import { BuyerEditForm } from 'ui/components/buyer/patterns/BuyerEditForm/BuyerEditForm';
import { useBuyerEdit } from './useBuyerEdit';
import { mqUser } from 'utils/responsive';

const BgWrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom; 40px;
`;

export const BuyerEdit: React.FC = () => {
    const {
        control,
        loading,
        errors,
        areaChoices,
        employeeChoices,
        revenueChoices,
        industryChoices,
        employeeLowerChoices,
        employeeUpperChoices,
        netAssetsLevelLowerChoices,
        netAssetsLevelUpperChoices,
        purchaseAmountLowerChoices,
        purchaseAmountUpperChoices,
        revenueScaleLowerChoices,
        revenueScaleUpperChoices,
        profitLevelLowerChoices,
        profitLevelUpperChoices,
        hasAcquisitionExperienceChoices,
        notRegistrationComplete,
        showSnackbar,
        editing,
        user,
        snackBarMessage,
        setEditing,
        setShowSnackbar,
        onCompanySelect,
        submit,
        setValue,
        watch,
        unPublish,
        reOpen,
    } = useBuyerEdit();

    if (!user) {
        return null;
    }

    const descriptions: { [key: string]: string[] } = {
        説明: [
            notRegistrationComplete
                ? '企業プロフィールを完成させて仲介会社からのオファー率をアップさせましょう'
                : 'オファーが来ない場合は、企業情報を修正して魅力的な文章を書きましょう',
        ],
    };
    return (
        <BgWrapper>
            <Wrapper>
                <SnackBar message={snackBarMessage} open={showSnackbar} setOpen={setShowSnackbar} />
                <div>
                    <PageTitle title="企業プロフィール" />
                    <AboutService descriptions={descriptions} />
                </div>
            </Wrapper>
            <BuyerEditForm
                user={user}
                control={control}
                loading={loading}
                errors={errors}
                areaChoices={areaChoices}
                employeeChoices={employeeChoices}
                revenueChoices={revenueChoices}
                industryChoices={industryChoices}
                employeeLowerChoices={employeeLowerChoices}
                employeeUpperChoices={employeeUpperChoices}
                revenueScaleLowerChoices={revenueScaleLowerChoices}
                revenueScaleUpperChoices={revenueScaleUpperChoices}
                profitLevelLowerChoices={profitLevelLowerChoices}
                profitLevelUpperChoices={profitLevelUpperChoices}
                netAssetsLevelLowerChoices={netAssetsLevelLowerChoices}
                netAssetsLevelUpperChoices={netAssetsLevelUpperChoices}
                purchaseAmountLowerChoices={purchaseAmountLowerChoices}
                purchaseAmountUpperChoices={purchaseAmountUpperChoices}
                hasAcquisitionExperienceChoices={hasAcquisitionExperienceChoices}
                submit={submit}
                setValue={setValue}
                watch={watch}
                onCompanySelect={onCompanySelect}
                showSnackbar={showSnackbar}
                setShowSnackbar={setShowSnackbar}
                editing={editing}
                setEditing={setEditing}
                unPublish={unPublish}
                reOpen={reOpen}
            />
        </BgWrapper>
    );
};
